import {  Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { BehaviorSubject, Observable } from 'rxjs';
import { TrashCommonsService } from './commons.service';
import { MachineActivity, MachineActivityService, MachineInfo, MachineInfoService, MachinePartInfo, MachinePartInfoService, Medium, MediumService, MediumVersion } from 'src/api/generated';

@Injectable({
  providedIn: 'root'
})
export class TrashService {
  public trashMachineInfoDataSource: DataSource<MachineInfo, string>;
  public trashMachineActivityDataSource: DataSource<MachineActivity, string>;
  public trashMachinePartInfoDataSource: DataSource<MachinePartInfo, string>;
  public trashMediumDataSource: DataSource<Medium, string>;
  public trashMediumVersionDataSource: DataSource<MediumVersion, string> | undefined;
  public actualVersion: number = 0;

  protected _currentMediumRow: BehaviorSubject<Medium | undefined> = new BehaviorSubject<Medium | undefined>(undefined);
  public currentMediumRow$: Observable<Medium | undefined> = this._currentMediumRow.asObservable();

  protected _currentInfoRow: BehaviorSubject<MachineInfo | undefined> = new BehaviorSubject<MachineInfo | undefined>(undefined);
  public currentInfoRow$: Observable<MachineInfo | undefined> = this._currentInfoRow.asObservable();

  public loadingVer: boolean = true;

  

  constructor(
    private _trashCommonSvc: TrashCommonsService,
    protected readonly _machineInfoSvc: MachineInfoService,
    protected readonly _machineActivitySvc: MachineActivityService,
    protected readonly _machinePartInfoSvc: MachinePartInfoService,
    protected readonly _mediumSvc: MediumService
  ) {
    this.trashMachineInfoDataSource = _trashCommonSvc.makeAsyncDataSource<MachineInfo, string>(this._machineInfoSvc);
    this.trashMachineActivityDataSource = this._trashCommonSvc.makeAsyncDataSource<MachineActivity, string>(this._machineActivitySvc);
    this.trashMachinePartInfoDataSource = this._trashCommonSvc.makeAsyncDataSource<MachinePartInfo, string>(this._machinePartInfoSvc);
    this.trashMediumDataSource = this._trashCommonSvc.makeAsyncDataSource<Medium, string>(this._mediumSvc);
    this.Init();
  }

  public set CurrentMediumRow(r: Medium) {
    this._currentMediumRow.next(r);
  }

  public set CurrentInfoRow(r: MachineInfo) {
    this._currentInfoRow.next(r);
  }

  public set CurrentMediumRowId(id: string) {
    if (this._currentMediumRow.value?.Id != id) {
      this.trashMediumDataSource.store().byKey(id).then((r) => { }); // do nothing just let it load record
    }
  }

  protected Init(): void {
    this.currentMediumRow$.subscribe({
      next: (r) => {
        this.refreshMediumVersions();
      }
    })
  }

  private refreshMediumVersions(): void {
    if (this._currentMediumRow != undefined && this._currentMediumRow.value?.Id != undefined) {
      this.loadingVer = true;
      this.trashMediumVersionDataSource = this._trashCommonSvc.makeAsyncDataSource<MediumVersion, string>(this._mediumSvc, this._currentMediumRow.value?.Id);
      // this.actualVersion = Math.max(this.trashMediumVersionDataSource);
      this.loadingVer = false;
    }
  }
}
